import styled from 'styled-components';
import Container from '../Container';
import Icon from '../Icon';
import Typography from '../Typography';
export const ChipStyled = styled(Container)(({ theme, color = 'blue', variant = 'light', }) => {
    var _a, _b;
    return ({
        backgroundColor: (_a = theme === null || theme === void 0 ? void 0 : theme.colors[color]) === null || _a === void 0 ? void 0 : _a[variant],
        color: variant == 'dark' ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors[color]) === null || _b === void 0 ? void 0 : _b.contrastText : theme === null || theme === void 0 ? void 0 : theme.palette.text.primary,
        padding: '4px 8px',
        borderRadius: '100px',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'inline-flex',
        gap: '4px',
        [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
            padding: '2px 8px',
        },
    });
});
export const ChipText = styled(Typography)(({ theme, }) => ({
    color: 'inherit',
    fontFamily: 'Maax',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '-0.1px',
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        fontSize: '14px',
        lineHeight: '20px',
    },
}));
export const ChipIcon = styled(Icon)(({ theme, }) => ({
    svg: {
        width: '16px',
        height: '16px',
    },
}));
//# sourceMappingURL=Chip.styles.js.map